"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentIntentStatusEnum = exports.StripeEventTypeEnum = void 0;
var StripeEventTypeEnum;
(function (StripeEventTypeEnum) {
    StripeEventTypeEnum["PAYMENT_INTENT_CREATED"] = "payment_intent.created";
    StripeEventTypeEnum["PAYMENT_INTENT_PROCESSING"] = "payment_intent.processing";
    StripeEventTypeEnum["PAYMENT_INTENT_SUCCEEDED"] = "payment_intent.succeeded";
    StripeEventTypeEnum["PAYMENT_INTENT_CANCELED"] = "payment_intent.canceled";
    StripeEventTypeEnum["PAYMENT_INTENT_PAYMENT_FAILED"] = "payment_intent.payment_failed";
    StripeEventTypeEnum["PAYMENT_INTENT_REQUIRES_ACTION"] = "payment_intent.requires_action";
    StripeEventTypeEnum["PAYMENT_METHOD_ATTACHED"] = "payment_method.attached";
    StripeEventTypeEnum["PAYMENT_METHOD_DETACHED"] = "payment_method.detached";
    StripeEventTypeEnum["CHARGE_PENDING"] = "charge.pending";
    StripeEventTypeEnum["CHARGE_UPDATED"] = "charge.updated";
    StripeEventTypeEnum["CHARGE_SUCCEEDED"] = "charge.succeeded";
    StripeEventTypeEnum["CHARGE_REFUNDED"] = "charge.refunded";
    StripeEventTypeEnum["CHARGE_FAILED"] = "charge.failed";
    StripeEventTypeEnum["TRANSFER_CREATED"] = "transfer.created";
    StripeEventTypeEnum["TRANSFER_UPDATED"] = "transfer.updated";
    StripeEventTypeEnum["TRANSFER_REVERSED"] = "transfer.reversed";
})(StripeEventTypeEnum = exports.StripeEventTypeEnum || (exports.StripeEventTypeEnum = {}));
var PaymentIntentStatusEnum;
(function (PaymentIntentStatusEnum) {
    PaymentIntentStatusEnum["CANCELED"] = "canceled";
    PaymentIntentStatusEnum["PROCESSING"] = "processing";
    PaymentIntentStatusEnum["REQUIRES_ACTION"] = "requires_action";
    PaymentIntentStatusEnum["REQUIRES_CAPTURE"] = "requires_capture";
    PaymentIntentStatusEnum["REQUIRES_CONFIRMATION"] = "requires_confirmation";
    PaymentIntentStatusEnum["REQUIRES_PAYMENT_METHOD"] = "requires_payment_method";
    PaymentIntentStatusEnum["SUCCEEDED"] = "succeeded";
})(PaymentIntentStatusEnum = exports.PaymentIntentStatusEnum || (exports.PaymentIntentStatusEnum = {}));
//# sourceMappingURL=webhooks.enums.js.map